// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"14":"fancyapps","335":"swiperPagination","644":"jcf","779":"fancyappscss","888":"lodash","920":"fuse","979":"swiper"}[chunkId] || chunkId) + ".bundle.js";
};